import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils';
import {modalAlert, modalConfirm} from 'app/utils/modals/popups';
import Post from 'app/utils/Post';
import {SelfExclusionForm} from './SelfExclusionForm';

export class FooterSelfExclusion extends Component<object, object> {
    formRef: SelfExclusionForm | null = null;

    setFormRef = (ref: SelfExclusionForm | null): void => {
        this.formRef = ref;
    };

    selfExclude = (event: React.MouseEvent): void => {
        event.preventDefault();

        modalConfirm(
            {
                element: <SelfExclusionForm ref={this.setFormRef} onSubmit={this.doSelfExclude} />,
                react: true
            },
            this.handleModalOk,
            null,
            {
                cancelText: I18n.t('common_log.cancelled'),
                classNameModal: 'popup__exclusion',
                okText: I18n.t('exclude_yes'),
                setFocus: false
            }
        );
    };

    handleModalOk = (): void => {
        if (this.formRef) {
            const {password, period} = this.formRef.getFormData();
            this.doSelfExclude(period, password);
        }
    };

    doSelfExclude = (period?: string, password?: string): void => {
        if (!period || !password) {
            return;
        }

        new Post({
            params: {password, period},
            url: '/egb_users/self_exclude'
        })
            .execute()
            .then(res => {
                if (!res.ok) {
                    throw new Error('Request failed');
                }
                return res.json();
            })
            .then(data => {
                modalAlert(
                    data.date
                        ? I18n.t('self_excluded', {date: data.date})
                        : I18n.t('self_excluded_forever'),
                    {
                        okClick: () => {
                            location.href = getLinkPath('/');
                        },
                        onClose: () => {
                            location.href = getLinkPath('/');
                        }

                    }
                );
            })
            .catch(() => {
                modalAlert(I18n.t('user.incorrect_password'));
            });
    };

    render(): ReactNode {
        return (
            <div className="footer__nav self-exclusion">
                <nav className="footer-nav">
                    <button
                        className="footer-nav__link cursor-pointer"
                        onClick={this.selfExclude}
                    >
                        {I18n.t('exclude')}
                    </button>
                </nav>
            </div>
        );
    }
}
